// Mock user database for demo purposes

export interface MockUser {
  id: string
  email: string
  password: string
  role: 'creator' | 'manager'
  name: string
  avatar?: string
  company?: string
  instagramConnected?: boolean
  isAdmin?: boolean
}

export const mockUsers: MockUser[] = [
  // Admin Account (can access both creator and manager)
  {
    id: 'admin-1',
    email: 'yasmin@creator.com',
    password: 'admin123',
    role: 'creator',
    name: 'Yasmin Sunman',
    avatar:
      'https://cdn.magicpatterns.com/uploads/5UvoNaV6trP2HazfDB17Dh/Bildschirmfoto_2026-01-20_um_11.23.35.png',
    instagramConnected: true,
    isAdmin: true,
  },

  // Creators
  {
    id: 'creator-2',
    email: 'tom@creator.com',
    password: 'creator123',
    role: 'creator',
    name: 'Tom Weber',
    avatar:
      'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=800',
    instagramConnected: false,
  },
  {
    id: 'creator-3',
    email: 'lisa@creator.com',
    password: 'creator123',
    role: 'creator',
    name: 'Lisa Schmidt',
    avatar:
      'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=800',
    instagramConnected: true,
  },

  // Managers
  {
    id: 'manager-1',
    email: 'admin@manager.com',
    password: 'manager123',
    role: 'manager',
    name: 'Alex Johnson',
    company: 'Talent Management Inc.',
    avatar:
      'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=800',
  },
  {
    id: 'manager-2',
    email: 'john@agency.com',
    password: 'manager123',
    role: 'manager',
    name: 'John Smith',
    company: 'Digital Agency Pro',
    avatar:
      'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=800',
  },
]

export function authenticateUser(
  email: string,
  password: string,
): MockUser | null {
  const user = mockUsers.find(
    (u) => u.email === email && u.password === password,
  )
  return user || null
}

export function getUserByEmail(email: string): MockUser | null {
  return mockUsers.find((u) => u.email === email) || null
}

export function getAllCreators(): MockUser[] {
  return mockUsers.filter((u) => u.role === 'creator')
}

export function getAllManagers(): MockUser[] {
  return mockUsers.filter((u) => u.role === 'manager')
}
